const Input = ({ children, className, ...props }) => <input
  className={`p-3 leading-5 bg-gray-300 rounded-full w-full ${className}`}
  {...props}
/>;

export default Input;